import React, { useMemo } from "react";

import { IPager } from "shared/types";

import { PagerContainer, PagerDots } from "./styles";
import { PagerButton } from "./PagerButton";

interface PagerProps extends IPager {
  isDisabled?: boolean;
}

export const Pager: React.FC<PagerProps> = ({
  totalPages,
  currentPage,
  onPageChange,
  isDisabled,
}) => {
  const hasNextPage = useMemo(() => {
    return totalPages > currentPage;
  }, [totalPages, currentPage]);
  const hasPrevPage = useMemo(() => {
    return currentPage > 1;
  }, [currentPage]);

  if (totalPages <= 1 || !currentPage) return null;

  return (
    <PagerContainer data-testid="pager">
      {hasPrevPage && (
        <>
          <li>
            <PagerButton
              isPrevious
              handleClick={() => onPageChange(currentPage - 1)}
              isDisabled={isDisabled}
            />
          </li>
          <li>
            <PagerButton handleClick={() => onPageChange(1)} page={1} isDisabled={isDisabled} />
          </li>
        </>
      )}
      {currentPage > 3 && (
        <li>
          <PagerDots>...</PagerDots>
        </li>
      )}
      {currentPage > 2 && (
        <li>
          <PagerButton
            handleClick={() => onPageChange(currentPage - 1)}
            page={currentPage - 1}
            isDisabled={isDisabled}
          />
        </li>
      )}
      <li>
        <PagerButton isActive page={currentPage} isDisabled={isDisabled} />
      </li>
      {currentPage < totalPages - 1 && (
        <li>
          <PagerButton
            handleClick={() => onPageChange(currentPage + 1)}
            page={currentPage + 1}
            isDisabled={isDisabled}
          />
        </li>
      )}
      {currentPage < totalPages - 2 && (
        <li>
          <PagerDots>...</PagerDots>
        </li>
      )}
      {hasNextPage && (
        <>
          <li>
            <PagerButton
              handleClick={() => onPageChange(totalPages)}
              page={totalPages}
              isDisabled={isDisabled}
            />
          </li>
          <li>
            <PagerButton
              isNext
              handleClick={() => onPageChange(currentPage + 1)}
              isDisabled={isDisabled}
            />
          </li>
        </>
      )}
    </PagerContainer>
  );
};
